// import React, { useState, useRef } from 'react';
// import {
//   Box,
//   Container,
//   Typography,
//   Card,
//   CardContent,
//   IconButton,
//   Chip,
//   Stack,
//   Avatar,
//   useMediaQuery,
//   useTheme
// } from '@mui/material';
// import {
//   Category as CategoryIcon,
//   People as UsersIcon,
//   RssFeed as RSSIcon,
//   PhotoLibrary as GalleryIcon,
//   Comment as CommentIcon,
//   Newspaper as NewspaperIcon,
//   Search as SearchIcon,
//   Language as LanguageIcon,
//   ArrowForward as ArrowIcon,
//   ArrowBack as ArrowBackIcon,
//   Notifications as NotificationIcon,
//   Poll as PollIcon,
//   Forum as ForumIcon,
//   Bookmark as BookmarkIcon
// } from '@mui/icons-material';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Pagination, Autoplay } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';

// const ModernFeatures2 = () => {
//   const [hoveredCard, setHoveredCard] = useState(null);
//   const [activeIndex, setActiveIndex] = useState(0);
//   const swiperRef = useRef(null);
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));

//   const features = [
//     {
//       icon: <CategoryIcon sx={{ fontSize: 50 }} />,
//       title: "Akıllı Kategori Sistemi",
//       subtitle: "Organize Content",
//       description: "Sınırsız kategori ve alt kategori desteği. Otomatik kategori önerileri ve akıllı içerik sınıflandırma. Drag & drop ile kolay yönetim.",
//       color: "#3b82f6",
//       gradient: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
//       features: ["Sınırsız Kategori", "Alt Kategoriler", "Otomatik Etiketleme", "Akıllı Filtreleme"],
//       stats: { value: "∞", label: "Kategori" }
//     },
//     {
//       icon: <UsersIcon sx={{ fontSize: 50 }} />,
//       title: "Rol Bazlı Yetkilendirme",
//       subtitle: "Team Management",
//       description: "Editör, yazar, muhabir rolleri ile ekip yönetimi. Her kullanıcı için özel yetki tanımlama. Detaylı aktivite logları.",
//       color: "#10b981",
//       gradient: "linear-gradient(135deg, #10b981 0%, #047857 100%)",
//       features: ["Editör Onayı", "Yazar Rolleri", "Muhabir Erişimi", "Özel Yetkiler"],
//       stats: { value: "5+", label: "Rol Tipi" }
//     },
//     {
//       icon: <RSSIcon sx={{ fontSize: 50 }} />,
//       title: "RSS & Haber Ajansı",
//       subtitle: "Content Aggregation",
//       description: "Otomatik RSS okuyucu ve haber ajansı entegrasyonu. Dış kaynaklardan haber çekme ve yayınlama. AA, İHA, DHA desteği.",
//       color: "#8b5cf6",
//       gradient: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
//       features: ["RSS Reader", "Ajans Entegrasyonu", "Otomatik Çekme", "Kaynak Yönetimi"],
//       stats: { value: "24/7", label: "Otomatik" }
//     },
//     {
//       icon: <GalleryIcon sx={{ fontSize: 50 }} />,
//       title: "Medya Yönetimi",
//       subtitle: "Rich Media Library",
//       description: "Gelişmiş medya kütüphanesi ile resim, video ve galeri yönetimi. Otomatik görsel optimizasyonu ve CDN desteği.",
//       color: "#f59e0b",
//       gradient: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
//       features: ["Foto Galeri", "Video Yönetimi", "Görsel Düzenleme", "Toplu Yükleme"],
//       stats: { value: "∞", label: "Medya" }
//     },
//     {
//       icon: <CommentIcon sx={{ fontSize: 50 }} />,
//       title: "Yorum & Etkileşim",
//       subtitle: "Community Engagement",
//       description: "Gelişmiş yorum sistemi, moderasyon araçları ve okuyucu etkileşim raporları. Spam filtreleme ve bildirim sistemi.",
//       color: "#ef4444",
//       gradient: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
//       features: ["Yorum Moderasyonu", "Spam Filtreleme", "Beğeni Sistemi", "Bildirimler"],
//       stats: { value: "AI", label: "Moderasyon" }
//     },
//     {
//       icon: <NewspaperIcon sx={{ fontSize: 50 }} />,
//       title: "E-Gazete Modülü",
//       subtitle: "Digital Newspaper",
//       description: "Dijital gazete yayını, PDF görüntüleyici ve arşiv sistemi. Basılı gazete deneyimi online. Mobil uyumlu okuma.",
//       color: "#06b6d4",
//       gradient: "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)",
//       features: ["PDF Yayın", "Sayfa Çevirme", "Arşiv Sistemi", "Mobil Okuma"],
//       stats: { value: "PDF", label: "Desteği" }
//     },
//     {
//       icon: <SearchIcon sx={{ fontSize: 50 }} />,
//       title: "Gelişmiş Arama",
//       subtitle: "Smart Search Engine",
//       description: "Akıllı arama motoru ile hızlı sonuçlar. Kategori, tarih ve yazar bazlı filtreleme. Elasticsearch entegrasyonu.",
//       color: "#ec4899",
//       gradient: "linear-gradient(135deg, #ec4899 0%, #db2777 100%)",
//       features: ["Hızlı Arama", "Filtreli Sonuçlar", "Otomatik Öneri", "Arama Geçmişi"],
//       stats: { value: "<1s", label: "Arama" }
//     },
//     {
//       icon: <LanguageIcon sx={{ fontSize: 50 }} />,
//       title: "Çoklu Dil Desteği",
//       subtitle: "Multi-Language",
//       description: "Türkçe ve İngilizce dil desteği. Kolay genişletilebilir lokalizasyon altyapısı. RTL dil desteği hazır.",
//       color: "#f97316",
//       gradient: "linear-gradient(135deg, #f97316 0%, #ea580c 100%)",
//       features: ["TR/EN Destek", "Dil Değiştirme", "Çeviri Yönetimi", "Yerel Formatlar"],
//       stats: { value: "2+", label: "Dil" }
//     },
//     {
//       icon: <NotificationIcon sx={{ fontSize: 50 }} />,
//       title: "Bildirim Sistemi",
//       subtitle: "Real-time Notifications",
//       description: "Gerçek zamanlı bildirimler, e-posta ve push notification desteği. Özelleştirilebilir bildirim kuralları.",
//       color: "#14b8a6",
//       gradient: "linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)",
//       features: ["Push Notification", "E-posta", "SMS Desteği", "Özel Kurallar"],
//       stats: { value: "Real", label: "Time" }
//     },
//     {
//       icon: <PollIcon sx={{ fontSize: 50 }} />,
//       title: "Anket & Oylama",
//       subtitle: "Interactive Polls",
//       description: "Okuyucu anketleri ve oylama sistemi. Gerçek zamanlı sonuçlar ve detaylı analitik. Çoktan seçmeli ve açık uçlu sorular.",
//       color: "#a855f7",
//       gradient: "linear-gradient(135deg, #a855f7 0%, #9333ea 100%)",
//       features: ["Çoktan Seçmeli", "Açık Uçlu", "Canlı Sonuçlar", "Analitik"],
//       stats: { value: "∞", label: "Anket" }
//     },
//     {
//       icon: <ForumIcon sx={{ fontSize: 50 }} />,
//       title: "Forum Sistemi",
//       subtitle: "Community Forum",
//       description: "Entegre forum sistemi ile okuyucu topluluğu oluşturun. Moderasyon araçları ve kullanıcı profilleri.",
//       color: "#0ea5e9",
//       gradient: "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
//       features: ["Tartışma Konuları", "Moderasyon", "Kullanıcı Profili", "Rozet Sistemi"],
//       stats: { value: "∞", label: "Konu" }
//     },
//     {
//       icon: <BookmarkIcon sx={{ fontSize: 50 }} />,
//       title: "Okuma Listesi",
//       subtitle: "Save for Later",
//       description: "Kullanıcılar favori haberlerini kaydedebilir. Okuma geçmişi ve öneri sistemi. Kişiselleştirilmiş içerik akışı.",
//       color: "#f43f5e",
//       gradient: "linear-gradient(135deg, #f43f5e 0%, #e11d48 100%)",
//       features: ["Favoriler", "Okuma Geçmişi", "Öneriler", "Paylaşım"],
//       stats: { value: "AI", label: "Öneri" }
//     }
//   ];

//   return (
//   <Box
//   sx={{
//     background: 'linear-gradient(44deg, #0f172a 0%, #1e3a8a 100%)',
//   }}
//   >
//       <Box
//       sx={{
//         py: { xs: 10, md: 16 },
//         backgroundColor:'#f1f6fb',
//         borderRadius: {xs : 0, md : '400px 0 400px 0'},
//         position: 'relative',
//         overflow: 'hidden',
//         '&::before': {
//           content: '""',
//           position: 'absolute',
//           top: 0,
//           left: 0,
//           right: 0,
//           bottom: 0,
//           background: `
//             radial-gradient(circle at 20% 20%, rgba(30, 64, 175, 0.05) 0%, transparent 50%),
//             radial-gradient(circle at 80% 80%, rgba(220, 38, 38, 0.05) 0%, transparent 50%),
//             radial-gradient(circle at 50% 50%, rgba(5, 150, 105, 0.03) 0%, transparent 50%)
//           `,
//           pointerEvents: 'none'
//         }
//       }}
//     >
//       <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2 }}>
//         {/* Header */}
//         <Box textAlign="center" mb={8}>
//           <Typography
//             variant="overline"
//             sx={{
//               fontSize: '0.9rem',
//               fontWeight: 900,
//               letterSpacing: '0.1em',
//               color: '#1e40af',
//               mb: 2,
//               display: 'block',
//               textTransform: 'uppercase'
//             }}
//           >
//             12 GÜÇLÜ ÖZELLİK
//           </Typography>
          
//           <Typography
//             variant="h2"
//             sx={{
//               fontSize: { xs: '2.8rem', md: '4rem' },
//               fontWeight: 800,
//               mb: 4,
//               background: 'linear-gradient(135deg, #1e293b 0%, #1e40af 50%, #dc2626 100%)',
//               backgroundClip: 'text',
//               WebkitBackgroundClip: 'text',
//               WebkitTextFillColor: 'transparent',
//               fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
//               lineHeight: 1.1,
//               position: 'relative',
//               '&::after': {
//                 content: '""',
//                 position: 'absolute',
//                 bottom: -8,
//                 left: '50%',
//                 transform: 'translateX(-50%)',
//                 width: 80,
//                 height: 4,
//                 background: 'linear-gradient(90deg, #1e40af, #dc2626)',
//                 borderRadius: 2
//               }
//             }}
//           >
//             Kapsamlı İçerik Yönetimi
//           </Typography>
          
//           <Typography
//             variant="h5"
//             sx={{
//               fontSize: { xs: '1.3rem', md: '1.5rem' },
//               color: '#64748b',
//               maxWidth: 700,
//               mx: 'auto',
//               lineHeight: 1.6,
//               fontWeight: 400,
//               mb: 6
//             }}
//           >
//             Haber yönetiminden okuyucu etkileşimine, ihtiyacınız olan tüm profesyonel araçlar. 
//             12 güçlü modül ile eksiksiz çözüm
//           </Typography>

//           {/* Stats */}
//           <Stack 
//             direction="row" 
//             spacing={4} 
//             justifyContent="center" 
//             flexWrap="wrap"
//             useFlexGap
//             sx={{ mb: 6 }}
//           >
//             <Box sx={{ textAlign: 'center' }}>
//               <Typography variant="h3" sx={{ fontWeight: 800, color: '#3b82f6', mb: 0.5 }}>
//                 12+
//               </Typography>
//               <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 600 }}>
//                 Modül
//               </Typography>
//             </Box>
//             <Box sx={{ textAlign: 'center' }}>
//               <Typography variant="h3" sx={{ fontWeight: 800, color: '#10b981', mb: 0.5 }}>
//                 ∞
//               </Typography>
//               <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 600 }}>
//                 İçerik
//               </Typography>
//             </Box>
//             <Box sx={{ textAlign: 'center' }}>
//               <Typography variant="h3" sx={{ fontWeight: 800, color: '#f59e0b', mb: 0.5 }}>
//                 24/7
//               </Typography>
//               <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 600 }}>
//                 Otomatik
//               </Typography>
//             </Box>
//           </Stack>
//         </Box>

//         {/* Navigation Buttons */}
//         <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 4 }}>
//           <IconButton
//             onClick={() => swiperRef.current?.slidePrev()}
//             sx={{
//               background: 'white',
//               border: '2px solid #e2e8f0',
//               color: '#1e40af',
//               width: 48,
//               height: 48,
//               '&:hover': {
//                 background: '#1e40af',
//                 borderColor: '#1e40af',
//                 color: 'white',
//                 transform: 'scale(1.1)'
//               },
//               transition: 'all 0.3s ease',
//               boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
//             }}
//           >
//             <ArrowBackIcon />
//           </IconButton>
//           <IconButton
//             onClick={() => swiperRef.current?.slideNext()}
//             sx={{
//               background: 'white',
//               border: '2px solid #e2e8f0',
//               color: '#1e40af',
//               width: 48,
//               height: 48,
//               '&:hover': {
//                 background: '#1e40af',
//                 borderColor: '#1e40af',
//                 color: 'white',
//                 transform: 'scale(1.1)'
//               },
//               transition: 'all 0.3s ease',
//               boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
//             }}
//           >
//             <ArrowIcon />
//           </IconButton>
//         </Box>

//         {/* Swiper */}
//         <Swiper
//           modules={[Navigation, Pagination, Autoplay]}
//           grabCursor={true}
//           centeredSlides={true}
//           slidesPerView={isMobile ? 1 : 3}
//           spaceBetween={isMobile ? 20 : 30}
//           autoplay={{
//             delay: 3500,
//             disableOnInteraction: false,
//             pauseOnMouseEnter: true
//           }}
//           pagination={{
//             clickable: true,
//             dynamicBullets: true
//           }}
//           loop={true}
//           speed={600}
//           onSwiper={(swiper) => {
//             swiperRef.current = swiper;
//           }}
//           onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
//           breakpoints={{
//             320: {
//               slidesPerView: 1,
//               spaceBetween: 20
//             },
//             768: {
//               slidesPerView: 2,
//               spaceBetween: 25
//             },
//             1024: {
//               slidesPerView: 3,
//               spaceBetween: 30
//             }
//           }}
//           style={{
//             paddingTop: '20px',
//             paddingBottom: '60px',
//             paddingLeft: '10px',
//             paddingRight: '10px'
//           }}
//         >
//           {features.map((feature, index) => (
//             <SwiperSlide key={index}>
//               <Card
//                 onMouseEnter={() => setHoveredCard(index)}
//                 onMouseLeave={() => setHoveredCard(null)}
//                 elevation={0}
//                 sx={{
//                   height: '100%',
//                   minHeight: '520px',
//                   background: '#ffffff',
//                   border: '1px solid #e2e8f0',
//                   borderRadius: 4,
//                   cursor: 'pointer',
//                   transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
//                   transform: hoveredCard === index ? 'translateY(-10px) scale(1.03)' : 'translateY(0) scale(1)',
//                   boxShadow: hoveredCard === index
//                     ? `0 30px 60px ${feature.color}20, 0 15px 30px rgba(0, 0, 0, 0.1)`
//                     : '0 4px 12px rgba(0, 0, 0, 0.05)',
//                   position: 'relative',
//                   overflow: 'hidden',
//                   '&::before': {
//                     content: '""',
//                     position: 'absolute',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     height: 4,
//                     background: feature.gradient,
//                     transform: hoveredCard === index ? 'scaleX(1)' : 'scaleX(0)',
//                     transformOrigin: 'left',
//                     transition: 'transform 0.3s ease'
//                   },
//                   '&:hover': {
//                     borderColor: feature.color
//                   }
//                 }}
//               >
//                 <CardContent sx={{ p: 5, height: '100%', display: 'flex', flexDirection: 'column' }}>
//                   {/* Stats Badge */}
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//                     <Avatar
//                       sx={{
//                         width: 90,
//                         height: 90,
//                         background: hoveredCard === index ? feature.gradient : `${feature.color}15`,
//                         color: hoveredCard === index ? 'white' : feature.color,
//                         transition: 'all 0.4s ease',
//                         transform: hoveredCard === index ? 'scale(1.1) rotate(5deg)' : 'scale(1)',
//                         boxShadow: hoveredCard === index ? `0 10px 30px ${feature.color}50` : 'none'
//                       }}
//                     >
//                       {feature.icon}
//                     </Avatar>
//                     <Box sx={{ textAlign: 'right' }}>
//                       <Typography variant="h4" sx={{ fontWeight: 800, color: feature.color }}>
//                         {feature.stats.value}
//                       </Typography>
//                       <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 600 }}>
//                         {feature.stats.label}
//                       </Typography>
//                     </Box>
//                   </Box>

//                   {/* Title & Subtitle */}
//                   <Typography
//                     variant="h5"
//                     sx={{
//                       fontWeight: 700,
//                       mb: 1,
//                       color: '#1e293b',
//                       fontSize: '1.5rem',
//                       fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif'
//                     }}
//                   >
//                     {feature.title}
//                   </Typography>
                  
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       fontWeight: 600,
//                       mb: 3,
//                       fontSize: '1rem',
//                       background: feature.gradient,
//                       backgroundClip: 'text',
//                       WebkitBackgroundClip: 'text',
//                       WebkitTextFillColor: 'transparent'
//                     }}
//                   >
//                     {feature.subtitle}
//                   </Typography>

//                   {/* Description */}
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       color: '#64748b',
//                       lineHeight: 1.7,
//                       mb: 4,
//                       fontSize: '0.95rem',
//                       flex: 1
//                     }}
//                   >
//                     {feature.description}
//                   </Typography>

//                   {/* Feature Tags */}
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       flexWrap: 'wrap',
//                       gap: 1
//                     }}
//                   >
//                     {feature.features.map((tag, tagIndex) => (
//                       <Chip
//                         key={tagIndex}
//                         label={tag}
//                         size="small"
//                         sx={{
//                           background: `${feature.color}20`,
//                           color: feature.color,
//                           fontSize: '0.75rem',
//                           height: '26px',
//                           fontWeight: 500,
//                           border: `1px solid ${feature.color}40`,
//                           transition: 'all 0.3s ease',
//                           '&:hover': {
//                             background: `${feature.color}30`,
//                             borderColor: feature.color
//                           }
//                         }}
//                       />
//                     ))}
//                   </Box>
//                 </CardContent>
//               </Card>
//             </SwiperSlide>
//           ))}
//         </Swiper>

//         {/* Custom Pagination Styles */}
//         <style jsx global>{`
//           .swiper-pagination-bullet {
//             background: #cbd5e1;
//             opacity: 1;
//             width: 10px;
//             height: 10px;
//           }
//           .swiper-pagination-bullet-active {
//             background: linear-gradient(90deg, #1e40af, #3b82f6);
//             width: 30px;
//             border-radius: 5px;
//           }
//         `}</style>
//       </Container>

//     </Box>
//   </Box>
//   );
// };

// export default ModernFeatures2;

import React, { useState, useRef } from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  IconButton,
  Chip,
  Stack,
  Avatar,
  useMediaQuery,
  useTheme
} from '@mui/material';
import {
  Category as CategoryIcon,
  People as UsersIcon,
  RssFeed as RSSIcon,
  PhotoLibrary as GalleryIcon,
  Comment as CommentIcon,
  Newspaper as NewspaperIcon,
  Search as SearchIcon,
  Language as LanguageIcon,
  ArrowForward as ArrowIcon,
  ArrowBack as ArrowBackIcon,
  Backup as BackupIcon,
  CloudDone as CloudIcon,
  Analytics as AnalyticsIcon,
  Api as ApiIcon,
  Notifications as NotificationIcon,
  Poll as PollIcon,
  Forum as ForumIcon,
  Bookmark as BookmarkIcon,
  Share as ShareIcon,
  Print as PrintIcon,
  Email as EmailIcon,
  Sms as SmsIcon
} from '@mui/icons-material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const AdditionalFeatures = () => {
  const [hoveredCard, setHoveredCard] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const features = [
    // ÖNCEKİ ÖZELLİKLER
    {
      icon: <CategoryIcon sx={{ fontSize: 50 }} />,
      title: "Akıllı Kategori Sistemi",
      subtitle: "Sınırsız Organizasyon",
      description: "Sınırsız kategori ve alt kategori desteği. Otomatik kategori önerileri ve akıllı içerik sınıflandırma. Sürükle-bırak ile kolay yönetim.",
      color: "#3b82f6",
      gradient: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
      features: ["Sınırsız Kategori", "Alt Kategoriler", "Otomatik Etiketleme", "Akıllı Filtreleme"],
      stats: { value: "∞", label: "Kategori" }
    },
    {
      icon: <UsersIcon sx={{ fontSize: 50 }} />,
      title: "Rol Bazlı Yetkilendirme",
      subtitle: "Ekip Yönetimi",
      description: "Editör, yazar, muhabir rolleri ile ekip yönetimi. Her kullanıcı için özel yetki tanımlama. Detaylı aktivite logları ve izleme.",
      color: "#10b981",
      gradient: "linear-gradient(135deg, #10b981 0%, #047857 100%)",
      features: ["Editör Onayı", "Yazar Rolleri", "Muhabir Erişimi", "Özel Yetkiler"],
      stats: { value: "5+", label: "Rol Tipi" }
    },
    {
      icon: <RSSIcon sx={{ fontSize: 50 }} />,
      title: "RSS & Haber Ajansı",
      subtitle: "İçerik Toplama",
      description: "Otomatik RSS okuyucu ve haber ajansı entegrasyonu. Dış kaynaklardan haber çekme ve yayınlama. AA, İHA, DHA desteği.",
      color: "#8b5cf6",
      gradient: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
      features: ["RSS Okuyucu", "Ajans Entegrasyonu", "Otomatik Çekme", "Kaynak Yönetimi"],
      stats: { value: "24/7", label: "Otomatik" }
    },
    {
      icon: <GalleryIcon sx={{ fontSize: 50 }} />,
      title: "Medya Yönetimi",
      subtitle: "Zengin Medya Kütüphanesi",
      description: "Gelişmiş medya kütüphanesi ile resim, video ve galeri yönetimi. Otomatik görsel optimizasyonu ve CDN desteği. Toplu yükleme.",
      color: "#f59e0b",
      gradient: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
      features: ["Foto Galeri", "Video Yönetimi", "Görsel Düzenleme", "Toplu Yükleme"],
      stats: { value: "∞", label: "Medya" }
    },
    {
      icon: <CommentIcon sx={{ fontSize: 50 }} />,
      title: "Yorum & Etkileşim",
      subtitle: "Topluluk Katılımı",
      description: "Gelişmiş yorum sistemi, moderasyon araçları ve okuyucu etkileşim raporları. Spam filtreleme ve otomatik bildirim sistemi.",
      color: "#ef4444",
      gradient: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
      features: ["Yorum Moderasyonu", "Spam Filtreleme", "Beğeni Sistemi", "Bildirimler"],
      stats: { value: "AI", label: "Moderasyon" }
    },
    {
      icon: <NewspaperIcon sx={{ fontSize: 50 }} />,
      title: "E-Gazete Modülü",
      subtitle: "Dijital Gazete",
      description: "Dijital gazete yayını, PDF görüntüleyici ve arşiv sistemi. Basılı gazete deneyimi online. Mobil uyumlu okuma deneyimi.",
      color: "#06b6d4",
      gradient: "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)",
      features: ["PDF Yayın", "Sayfa Çevirme", "Arşiv Sistemi", "Mobil Okuma"],
      stats: { value: "PDF", label: "Desteği" }
    },
    {
      icon: <SearchIcon sx={{ fontSize: 50 }} />,
      title: "Gelişmiş Arama",
      subtitle: "Akıllı Arama Motoru",
      description: "Akıllı arama motoru ile hızlı sonuçlar. Kategori, tarih ve yazar bazlı filtreleme. Elasticsearch entegrasyonu ve otomatik öneri.",
      color: "#ec4899",
      gradient: "linear-gradient(135deg, #ec4899 0%, #db2777 100%)",
      features: ["Hızlı Arama", "Filtreli Sonuçlar", "Otomatik Öneri", "Arama Geçmişi"],
      stats: { value: "<1s", label: "Arama" }
    },
    {
      icon: <LanguageIcon sx={{ fontSize: 50 }} />,
      title: "Çoklu Dil Desteği",
      subtitle: "Çok Dilli Platform",
      description: "Türkçe ve İngilizce dil desteği. Kolay genişletilebilir lokalizasyon altyapısı. RTL dil desteği hazır. Dil bazlı içerik yönetimi.",
      color: "#f97316",
      gradient: "linear-gradient(135deg, #f97316 0%, #ea580c 100%)",
      features: ["TR/EN Destek", "Dil Değiştirme", "Çeviri Yönetimi", "Yerel Formatlar"],
      stats: { value: "2+", label: "Dil" }
    },
    // YENİ ÖZELLIKLER
    {
      icon: <BackupIcon sx={{ fontSize: 50 }} />,
      title: "Otomatik Yedekleme",
      subtitle: "Verileriniz Her Zaman Güvende",
      description: "Günlük otomatik yedekleme sistemi ile verileriniz her zaman güvende. İstediğiniz zaman geri yükleme yapabilirsiniz. Bulut ve yerel yedekleme seçenekleri.",
      color: "#0ea5e9",
      gradient: "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
      features: ["Günlük Yedekleme", "Bulut Depolama", "Geri Yükleme", "Otomatik Sistem"],
      stats: { value: "7/24", label: "Yedekleme" }
    },
    {
      icon: <CloudIcon sx={{ fontSize: 50 }} />,
      title: "Bulut Altyapı",
      subtitle: "Sınırsız Ölçeklenebilirlik",
      description: "Bulut tabanlı altyapı ile sınırsız trafik kapasitesi. Otomatik ölçeklendirme ve yük dengeleme. Yüksek erişilebilirlik garantisi.",
      color: "#14b8a6",
      gradient: "linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)",
      features: ["Otomatik Ölçekleme", "Yük Dengeleme", "CDN Desteği", "Yüksek Erişim"],
      stats: { value: "99.9%", label: "Uptime" }
    },
    {
      icon: <AnalyticsIcon sx={{ fontSize: 50 }} />,
      title: "Detaylı Raporlama",
      subtitle: "İstatistik ve Analiz",
      description: "Gelişmiş analitik raporları ile içerik performansını takip edin. Okuyucu davranışları, trafik kaynakları ve içerik başarı metrikleri.",
      color: "#a855f7",
      gradient: "linear-gradient(135deg, #a855f7 0%, #9333ea 100%)",
      features: ["Trafik Analizi", "İçerik Performansı", "Okuyucu Davranışı", "Özel Raporlar"],
      stats: { value: "50+", label: "Rapor" }
    },
    {
      icon: <ApiIcon sx={{ fontSize: 50 }} />,
      title: "API Entegrasyonu",
      subtitle: "Dış Sistem Bağlantıları",
      description: "RESTful API ile mobil uygulama ve üçüncü parti sistemlere entegrasyon. Webhook desteği ve özel API uç noktaları oluşturma.",
      color: "#f43f5e",
      gradient: "linear-gradient(135deg, #f43f5e 0%, #e11d48 100%)",
      features: ["RESTful API", "Webhook", "Mobil Entegrasyon", "Özel Uç Nokta"],
      stats: { value: "API", label: "Erişim" }
    },
    {
      icon: <NotificationIcon sx={{ fontSize: 50 }} />,
      title: "Bildirim Yönetimi",
      subtitle: "Çoklu Kanal Bildirimleri",
      description: "E-posta, SMS ve push notification ile okuyucularınıza ulaşın. Özelleştirilebilir bildirim kuralları ve zamanlama seçenekleri.",
      color: "#84cc16",
      gradient: "linear-gradient(135deg, #84cc16 0%, #65a30d 100%)",
      features: ["E-posta Bildirimi", "SMS Desteği", "Push Notification", "Zamanlama"],
      stats: { value: "3", label: "Kanal" }
    },
    {
      icon: <PollIcon sx={{ fontSize: 50 }} />,
      title: "Anket Sistemi",
      subtitle: "Okuyucu Görüşleri",
      description: "İnteraktif anket ve oylama sistemi. Çoktan seçmeli, açık uçlu ve derecelendirme soruları. Gerçek zamanlı sonuçlar ve detaylı analiz.",
      color: "#f59e0b",
      gradient: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
      features: ["Çoktan Seçmeli", "Açık Uçlu", "Canlı Sonuçlar", "Grafik Analiz"],
      stats: { value: "∞", label: "Anket" }
    },
    {
      icon: <ForumIcon sx={{ fontSize: 50 }} />,
      title: "Forum Modülü",
      subtitle: "Topluluk Platformu",
      description: "Entegre forum sistemi ile okuyucu topluluğu oluşturun. Tartışma konuları, moderasyon araçları ve kullanıcı profilleri.",
      color: "#8b5cf6",
      gradient: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
      features: ["Tartışma Konuları", "Moderasyon", "Kullanıcı Profili", "Rozet Sistemi"],
      stats: { value: "∞", label: "Konu" }
    },
    {
      icon: <BookmarkIcon sx={{ fontSize: 50 }} />,
      title: "Okuma Listesi",
      subtitle: "Kişisel Koleksiyon",
      description: "Kullanıcılar favori haberlerini kaydedebilir. Okuma geçmişi takibi ve kişiselleştirilmiş içerik önerileri. Çapraz cihaz senkronizasyonu.",
      color: "#ec4899",
      gradient: "linear-gradient(135deg, #ec4899 0%, #db2777 100%)",
      features: ["Favoriler", "Okuma Geçmişi", "Kişisel Öneriler", "Senkronizasyon"],
      stats: { value: "∞", label: "Kayıt" }
    },
    {
      icon: <ShareIcon sx={{ fontSize: 50 }} />,
      title: "Sosyal Paylaşım",
      subtitle: "Viral İçerik Yönetimi",
      description: "Tüm sosyal medya platformlarına tek tıkla paylaşım. Otomatik meta tag oluşturma ve Open Graph desteği. Paylaşım istatistikleri.",
      color: "#06b6d4",
      gradient: "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)",
      features: ["Sosyal Medya", "Meta Tag", "Open Graph", "Paylaşım İstatistiği"],
      stats: { value: "10+", label: "Platform" }
    },
    {
      icon: <PrintIcon sx={{ fontSize: 50 }} />,
      title: "Yazdırma Modu",
      subtitle: "Optimize Edilmiş Çıktı",
      description: "Haberler için özel yazdırma görünümü. Reklamsız, temiz ve optimize edilmiş çıktı. PDF olarak kaydetme özelliği.",
      color: "#a855f7",
      gradient: "linear-gradient(135deg, #a855f7 0%, #9333ea 100%)",
      features: ["Temiz Görünüm", "Reklamsız", "PDF Kayıt", "Optimize Çıktı"],
      stats: { value: "PDF", label: "Destek" }
    },
    {
      icon: <EmailIcon sx={{ fontSize: 50 }} />,
      title: "E-posta Kampanyaları",
      subtitle: "Toplu Mail Gönderimi",
      description: "Abonelerinize toplu e-posta gönderimi. Şablon tasarımcısı ve otomatik gönderim planlaması. Açılma ve tıklama istatistikleri.",
      color: "#0ea5e9",
      gradient: "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
      features: ["Toplu Gönderim", "Şablon Tasarımcı", "Zamanlama", "İstatistik"],
      stats: { value: "∞", label: "Abone" }
    },
    {
      icon: <SmsIcon sx={{ fontSize: 50 }} />,
      title: "SMS Entegrasyonu",
      subtitle: "Anlık Bilgilendirme",
      description: "SMS ile önemli haberleri ve bildirimleri gönderin. Toplu SMS gönderimi ve şablon yönetimi. Detaylı gönderim raporları.",
      color: "#f43f5e",
      gradient: "linear-gradient(135deg, #f43f5e 0%, #e11d48 100%)",
      features: ["Toplu SMS", "Şablon Yönetimi", "Anlık Gönderim", "Raporlama"],
      stats: { value: "SMS", label: "Destek" }
    },
    {
      icon: <BackupIcon sx={{ fontSize: 50 }} />,
      title: "Otomatik Yedekleme",
      subtitle: "Veri Güvenliği",
      description: "Günlük otomatik yedekleme sistemi ile verileriniz her zaman güvende. İstediğiniz zaman geri yükleme yapabilirsiniz. Bulut ve yerel yedekleme.",
      color: "#3b82f6",
      gradient: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
      features: ["Günlük Yedekleme", "Bulut Depolama", "Geri Yükleme", "Otomatik Sistem"],
      stats: { value: "7/24", label: "Yedekleme" }
    },
    {
      icon: <CloudIcon sx={{ fontSize: 50 }} />,
      title: "Bulut Altyapı",
      subtitle: "Sınırsız Ölçeklenebilirlik",
      description: "Bulut tabanlı altyapı ile sınırsız trafik kapasitesi. Otomatik ölçeklendirme ve yük dengeleme. Yüksek erişilebilirlik garantisi.",
      color: "#14b8a6",
      gradient: "linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)",
      features: ["Otomatik Ölçekleme", "Yük Dengeleme", "CDN Desteği", "Yüksek Erişim"],
      stats: { value: "99.9%", label: "Uptime" }
    },
    {
      icon: <AnalyticsIcon sx={{ fontSize: 50 }} />,
      title: "Detaylı Raporlama",
      subtitle: "İstatistik ve Analiz",
      description: "Gelişmiş analitik raporları ile içerik performansını takip edin. Okuyucu davranışları, trafik kaynakları ve içerik başarı metrikleri.",
      color: "#8b5cf6",
      gradient: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
      features: ["Trafik Analizi", "İçerik Performansı", "Okuyucu Davranışı", "Özel Raporlar"],
      stats: { value: "50+", label: "Rapor" }
    },
    {
      icon: <ApiIcon sx={{ fontSize: 50 }} />,
      title: "API Entegrasyonu",
      subtitle: "Dış Sistem Bağlantıları",
      description: "RESTful API ile mobil uygulama ve üçüncü parti sistemlere entegrasyon. Webhook desteği ve özel API uç noktaları oluşturma.",
      color: "#10b981",
      gradient: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
      features: ["RESTful API", "Webhook", "Mobil Entegrasyon", "Özel Uç Nokta"],
      stats: { value: "API", label: "Erişim" }
    }
  ];

  return (
    <Box
      sx={{
        background: 'linear-gradient(44deg, #0f172a 0%, #1e3a8a 100%)'
      }}
    >
      <Box
        sx={{
          py: { xs: 10, md: 16 },
          backgroundColor: '#f1f6fb',
          borderRadius: { xs: 0, md: '400px 0 400px 0' },
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `
              radial-gradient(circle at 20% 20%, rgba(30, 64, 175, 0.05) 0%, transparent 50%),
              radial-gradient(circle at 80% 80%, rgba(220, 38, 38, 0.05) 0%, transparent 50%),
              radial-gradient(circle at 50% 50%, rgba(5, 150, 105, 0.03) 0%, transparent 50%)
            `,
            pointerEvents: 'none'
          }
        }}
      >
        <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2 }}>
          {/* Header */}
          <Box textAlign="center" mb={8}>
            <Typography
              variant="overline"
              sx={{
                fontSize: '0.9rem',
                fontWeight: 900,
                letterSpacing: '0.1em',
                color: '#1e40af',
                mb: 2,
                display: 'block',
                textTransform: 'uppercase'
              }}
            >
              16 EK GÜÇLÜ ÖZELLİK
            </Typography>
            
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2.8rem', md: '4rem' },
                fontWeight: 800,
                mb: 4,
                background: 'linear-gradient(135deg, #1e293b 0%, #1e40af 50%, #dc2626 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                lineHeight: 1.1,
                position: 'relative',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: -8,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: 80,
                  height: 4,
                  background: 'linear-gradient(90deg, #1e40af, #dc2626)',
                  borderRadius: 2
                }
              }}
            >
              Daha Fazla Özellik
            </Typography>
            
            <Typography
              variant="h5"
              sx={{
                fontSize: { xs: '1.3rem', md: '1.5rem' },
                color: '#64748b',
                maxWidth: 700,
                mx: 'auto',
                lineHeight: 1.6,
                fontWeight: 400,
                mb: 6
              }}
            >
              Kategori yönetiminden API entegrasyonuna, profesyonel haber platformu için 
              gereken tüm ek özellikler
            </Typography>

            {/* Stats */}
            <Stack 
              direction="row" 
              spacing={4} 
              justifyContent="center" 
              flexWrap="wrap"
              useFlexGap
              sx={{ mb: 6 }}
            >
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="h3" sx={{ fontWeight: 800, color: '#3b82f6', mb: 0.5 }}>
                  16+
                </Typography>
                <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 600 }}>
                  Ek Modül
                </Typography>
              </Box>
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="h3" sx={{ fontWeight: 800, color: '#10b981', mb: 0.5 }}>
                  100%
                </Typography>
                <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 600 }}>
                  Otomatik
                </Typography>
              </Box>
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="h3" sx={{ fontWeight: 800, color: '#f59e0b', mb: 0.5 }}>
                  ∞
                </Typography>
                <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 600 }}>
                  Entegrasyon
                </Typography>
              </Box>
            </Stack>
          </Box>

          {/* Navigation Buttons */}
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 4 }}>
            <IconButton
              onClick={() => swiperRef.current?.slidePrev()}
              sx={{
                background: 'white',
                border: '2px solid #e2e8f0',
                color: '#1e40af',
                width: 48,
                height: 48,
                '&:hover': {
                  background: '#1e40af',
                  borderColor: '#1e40af',
                  color: 'white',
                  transform: 'scale(1.1)'
                },
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
              }}
            >
              <ArrowBackIcon />
            </IconButton>
            <IconButton
              onClick={() => swiperRef.current?.slideNext()}
              sx={{
                background: 'white',
                border: '2px solid #e2e8f0',
                color: '#1e40af',
                width: 48,
                height: 48,
                '&:hover': {
                  background: '#1e40af',
                  borderColor: '#1e40af',
                  color: 'white',
                  transform: 'scale(1.1)'
                },
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
              }}
            >
              <ArrowIcon />
            </IconButton>
          </Box>

          {/* Swiper */}
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            grabCursor={true}
            centeredSlides={true}
            slidesPerView={isMobile ? 1 : 3}
            spaceBetween={isMobile ? 20 : 30}
            autoplay={{
              delay: 3500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }}
            pagination={{
              clickable: true,
              dynamicBullets: true
            }}
            loop={true}
            speed={600}
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 20
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 25
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 30
              }
            }}
            style={{
              paddingTop: '20px',
              paddingBottom: '60px',
              paddingLeft: '10px',
              paddingRight: '10px'
            }}
          >
            {features.map((feature, index) => (
              <SwiperSlide key={index}>
                <Card
                  onMouseEnter={() => setHoveredCard(index)}
                  onMouseLeave={() => setHoveredCard(null)}
                  elevation={0}
                  sx={{
                    height: '100%',
                    minHeight: '520px',
                    background: '#ffffff',
                    border: '1px solid #e2e8f0',
                    borderRadius: 4,
                    cursor: 'pointer',
                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                    transform: hoveredCard === index ? 'translateY(-10px) scale(1.03)' : 'translateY(0) scale(1)',
                    boxShadow: hoveredCard === index
                      ? `0 30px 60px ${feature.color}20, 0 15px 30px rgba(0, 0, 0, 0.1)`
                      : '0 4px 12px rgba(0, 0, 0, 0.05)',
                    position: 'relative',
                    overflow: 'hidden',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      height: 4,
                      background: feature.gradient,
                      transform: hoveredCard === index ? 'scaleX(1)' : 'scaleX(0)',
                      transformOrigin: 'left',
                      transition: 'transform 0.3s ease'
                    },
                    '&:hover': {
                      borderColor: feature.color
                    }
                  }}
                >
                  <CardContent sx={{ p: 5, height: '100%', display: 'flex', flexDirection: 'column' }}>
                    {/* Stats Badge & Icon */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                      <Avatar
                        sx={{
                          width: 90,
                          height: 90,
                          background: hoveredCard === index ? feature.gradient : `${feature.color}15`,
                          color: hoveredCard === index ? 'white' : feature.color,
                          transition: 'all 0.4s ease',
                          transform: hoveredCard === index ? 'scale(1.1) rotate(5deg)' : 'scale(1)',
                          boxShadow: hoveredCard === index ? `0 10px 30px ${feature.color}50` : 'none'
                        }}
                      >
                        {feature.icon}
                      </Avatar>
                      <Box sx={{ textAlign: 'right' }}>
                        <Typography variant="h4" sx={{ fontWeight: 800, color: feature.color }}>
                          {feature.stats.value}
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 600 }}>
                          {feature.stats.label}
                        </Typography>
                      </Box>
                    </Box>

                    {/* Title & Subtitle */}
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: 700,
                        mb: 1,
                        color: '#1e293b',
                        fontSize: '1.5rem',
                        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif'
                      }}
                    >
                      {feature.title}
                    </Typography>
                    
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 600,
                        mb: 3,
                        fontSize: '1rem',
                        background: feature.gradient,
                        backgroundClip: 'text',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent'
                      }}
                    >
                      {feature.subtitle}
                    </Typography>

                    {/* Description */}
                    <Typography
                      variant="body2"
                      sx={{
                        color: '#64748b',
                        lineHeight: 1.7,
                        mb: 4,
                        fontSize: '0.95rem',
                        flex: 1
                      }}
                    >
                      {feature.description}
                    </Typography>

                    {/* Feature Tags */}
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1
                      }}
                    >
                      {feature.features.map((tag, tagIndex) => (
                        <Chip
                          key={tagIndex}
                          label={tag}
                          size="small"
                          sx={{
                            background: `${feature.color}20`,
                            color: feature.color,
                            fontSize: '0.75rem',
                            height: '26px',
                            fontWeight: 500,
                            border: `1px solid ${feature.color}40`,
                            transition: 'all 0.3s ease',
                            '&:hover': {
                              background: `${feature.color}30`,
                              borderColor: feature.color
                            }
                          }}
                        />
                      ))}
                    </Box>
                  </CardContent>
                </Card>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom Pagination Styles */}
          <style jsx global>{`
            .swiper-pagination-bullet {
              background: #cbd5e1;
              opacity: 1;
              width: 10px;
              height: 10px;
            }
            .swiper-pagination-bullet-active {
              background: linear-gradient(90deg, #1e40af, #3b82f6);
              width: 30px;
              border-radius: 5px;
            }
          `}</style>
        </Container>
      </Box>
    </Box>
  );
};

export default AdditionalFeatures;